export default {
      id: "icon-yeux-usage",
      viewBox: "0 0 93 54.3",
      url: __webpack_public_path__ + "icons.svg#icon-yeux",
      toString: function () {
        return this.url;
      }
    }